<template>
    <div class="tooltip">
        <i class="far fa-question-circle"></i>
        <span v-if="text" class="tooltiptext" :class="{left: left}">{{ text }}</span>
    </div>
</template>

<script>
export default {
    name: "HelpTooltip",
    props: {
        text: {
            type: String,
            default: '',
        },
        left: {
            type: Boolean,
            default: false,
        }
    },
}
</script>

<style scoped lang="scss">
.tooltip {
    position: relative;
    font-size: 1rem;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;

    .tooltiptext {
        visibility: hidden;
        width: 250px;
        background-color: black;
        color: #fff;
        text-align: center;
        padding: 5px 10px;
        border-radius: 6px;
        font-weight: 400;
        font-size: 1rem;
        position: absolute;
        z-index: 1000;
        opacity: 0.8;
        left: 100%;
        &.left {
            left: auto;
            right: 100%;
        }
    }

    &:hover .tooltiptext {
        visibility: visible;
    }
}
</style>